import React, { Fragment } from 'react';

const CustomDropDownField = field => (
    <Fragment>
        <select required={field.required || false} onChange={field.onChange} className={field.className} disabled={field.disabled || false} {...field.input}>{field.children}</select>
    </Fragment>
);

export default CustomDropDownField;
